import React from "react";
import { EnhancedHeader } from "@/components/ui";
import { Separator } from "@/components/ui/separator";
import { ScrollArea } from "@/components/ui/scroll-area";

export default function TermsOfServicePage() {
  return (
    <div className="min-h-screen bg-black text-white">
      <EnhancedHeader
        title="Terms of Service"
        backPath="/user-settings"
        coloredText={true}
        rightContent={null}
        showBackButton={true}
      />

      <div className="max-w-md mx-auto px-4 pb-10">
        <div className="bg-zinc-900 rounded-xl overflow-hidden mb-4">
          <div className="p-4">
            <p className="text-sm text-gray-400 mb-4">Last Updated: May 19, 2025</p>
            
            <ScrollArea className="h-[calc(100vh-180px)] pr-4">
              <div className="space-y-6">
                <section>
                  <h3 className="text-green-400 font-medium mb-2">1. Acceptance of Terms</h3>
                  <p className="text-sm text-gray-300">
                    By accessing or using Spar Legends, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.
                  </p>
                </section>

                <Separator className="bg-zinc-800" />

                <section>
                  <h3 className="text-green-400 font-medium mb-2">2. User Accounts</h3>
                  <p className="text-sm text-gray-300 mb-2">
                    When you create an account with us, you must provide accurate and complete information. You are responsible for maintaining the security of your account and password.
                  </p>
                  <p className="text-sm text-gray-300">
                    We reserve the right to refuse service, terminate accounts, remove or edit content, or cancel orders at our sole discretion.
                  </p>
                </section>
                
                <Separator className="bg-zinc-800" />

                <section>
                  <h3 className="text-green-400 font-medium mb-2">3. User Content</h3>
                  <p className="text-sm text-gray-300 mb-2">
                    By submitting content to Spar Legends, you grant us a worldwide, non-exclusive, royalty-free license to use, reproduce, adapt, publish, translate, and distribute your content.
                  </p>
                  <p className="text-sm text-gray-300">
                    You are solely responsible for the content you post and agree not to submit material that is illegal, offensive, or infringes on another's rights.
                  </p>
                </section>
                
                <Separator className="bg-zinc-800" />

                <section>
                  <h3 className="text-green-400 font-medium mb-2">4. In-Game Currency and Purchases</h3>
                  <p className="text-sm text-gray-300 mb-2">
                    Spar Legends may offer virtual currency for purchase. All purchases are final and non-refundable, except as required by applicable law.
                  </p>
                  <p className="text-sm text-gray-300">
                    Virtual currency has no real-world value and cannot be exchanged for cash or other items of monetary value.
                  </p>
                </section>
                
                <Separator className="bg-zinc-800" />

                <section>
                  <h3 className="text-green-400 font-medium mb-2">5. Intellectual Property</h3>
                  <p className="text-sm text-gray-300">
                    All content included on Spar Legends, such as text, graphics, logos, icons, images, audio clips, digital downloads, and software, is the property of Spar Legends or its content suppliers and is protected by international copyright laws.
                  </p>
                </section>
                
                <Separator className="bg-zinc-800" />

                <section>
                  <h3 className="text-green-400 font-medium mb-2">6. Termination</h3>
                  <p className="text-sm text-gray-300">
                    We may terminate or suspend your account immediately, without prior notice or liability, for any reason, including without limitation if you breach the Terms of Service.
                  </p>
                </section>
                
                <Separator className="bg-zinc-800" />

                <section>
                  <h3 className="text-green-400 font-medium mb-2">7. Limitation of Liability</h3>
                  <p className="text-sm text-gray-300">
                    In no event shall Spar Legends, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses.
                  </p>
                </section>
                
                <Separator className="bg-zinc-800" />

                <section>
                  <h3 className="text-green-400 font-medium mb-2">8. Governing Law</h3>
                  <p className="text-sm text-gray-300">
                    These Terms shall be governed and construed in accordance with the laws of the Ghana, without regard to its conflict of law provisions.
                  </p>
                </section>
                
                <Separator className="bg-zinc-800" />

                <section>
                  <h3 className="text-green-400 font-medium mb-2">9. Changes to Terms</h3>
                  <p className="text-sm text-gray-300">
                    We reserve the right to modify or replace these Terms at any time. We will provide notice of any changes by posting the new Terms on this page.
                  </p>
                </section>
                
                <Separator className="bg-zinc-800" />

                <section>
                  <h3 className="text-green-400 font-medium mb-2">10. Contact Information</h3>
                  <p className="text-sm text-gray-300">
                    If you have any questions about these Terms, please contact us through our support page or email at support@sparlegends.com.
                  </p>
                </section>
              </div>
            </ScrollArea>
          </div>
        </div>
      </div>
    </div>
  );
}